import styles from '../pages/Admin/ActiveJobDetails.module.css';
import { Button } from '@deere/fuel-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const CopyJobAndPasteAgain = ({ bidobj }) => {
    const navigate = useNavigate();
    const callCreatePage = () => {
        const bidcopy = { ...bidobj };
        delete bidcopy.id;
        delete bidcopy.postingStartDate;
        delete bidcopy.endDate;
        delete bidcopy.noOfOpenings;
        navigate('/create-job/', {
            state: {
                bidObj: bidcopy,
                activeJobCopyCall: true,
            },
        });
    };
    return (
        <Button
            variant="primary"
            onClick={callCreatePage}
            className={styles.pageLevelButton}
        >
            Copy Job & Post Again
        </Button>
    );
};
